import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import * as XLSX from "xlsx";
//import Pagination from "../../CommonUI/Pagination/Pagination";
// import Pagination from "https://cdn.skypack.dev/rc-pagination@3.1.15";
import execl from "../../../images/excel.png";
import Pagination from "rc-pagination";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import NodatafoundImg from "../../../images/no-data.png";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";

function DividendHistory() {
  const dayjs = require("dayjs");
  const currentDate = dayjs();
  const lastMonthDate = currentDate.subtract(1, "day").subtract(1, "month");
  const lastMonthDateFormatted = lastMonthDate.format("YYYY-MM-DD");
  const [valuedate, setValuedate] = useState(dayjs());
  const [StartDate, setStartDate] = useState(dayjs(lastMonthDateFormatted));
  const [valuedatelatest, setValuedateLatest] = useState("");
  const [data, setData] = useState("");
  const [dataDrop, setDataDropdown] = useState("");
  const [values, setValues] = useState("Equity");
  const [Valuesdrop, setValuesdrop] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [current, setCurrent] = useState(1);
  const [loadingshow, setloadingshow] = useState(false);
  const [endDate, setlastDate] = useState("");
  const [dataDropFund, setDataDropdownFund] = useState("");
  const [DropdownFundCode, setDataDropdownFundCode] = useState("");
  const [DropdownFundType, setDataDropdownFundType] = useState("");
  const [selectedOptionFundCode, setSelectedOption] = useState("");
  const [showAdditionalDropdowns, setShowAdditionalDropdowns] = useState(false);
  const [optiondesc, setSelectedOptionOptionDesc] = useState("");
  const [showAdditionalDropdowns2, setShowAdditionalDropdowns2] =
    useState(false);
  const [selectedOptionFundtype, setSelectedOptionFundCode] = useState("");
  const [showAdditionalDropdowns1, setShowAdditionalDropdowns1] =
    useState(false);
  const [activeTab, setActiveTab] = useState("Equity");

  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  let PageSize = size;

  useEffect(() => {
    document.getElementById("datedrop").style.display = "none";
    setloadingshow(true);
    const dateString = dayjs(valuedate).format("YYYY-MM-DD");
    const dateStringLast = dayjs(StartDate).format("YYYY-MM-DD");
    setTimeout(() => {
      GetPostMethodData(BaseURL + "GetDividendHistory", {
        type: values,
        IVSchemeCode: Valuesdrop,
        IDstartdate: dateStringLast,
        IDenddate: dateString,
      }).then((data) => {
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
        } else {
          setData("");
          setloadingshow(false);
        }
      });
    }, 2000);
  }, [BaseURL, values, Valuesdrop]);

  useEffect(() => {
    setSelectedOptionFundCode("");
  }, [selectedOptionFundCode]);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: "",
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFund(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundCode(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "dropFundcode")
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: selectedOptionFundtype,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundType(DecryptAESdata(data.data));
        setloadingshow(false);
      }
      // if(selectedOptionFundtype != ""){
      //     document.getElementsByClassName('btn-go-nav').style.display = "block";
      // }
    });
  }, [BaseURL, values, selectedOptionFundCode, selectedOptionFundtype]);
  const handleChangeFundName = (event) => {
    // setValuedateLatest('')
    // setlastDate('')
    document.getElementById("datedrop").style.display = "block";
    // document.querySelector('datedrop').style.display = 'block';
    setData("");
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns(true);
    } else {
      setShowAdditionalDropdowns(false);
    }
  };

  const columns = [
    { label: "Scheme Code", value: "SchemeCode" },
    { label: "Category Id", value: "categoryid" },
    { label: "Scheme Name", value: "schemename" },
    { label: "NAV Date", value: "navdate" },
    { label: "NAV", value: "nav" },
    { label: "Corporate IDCW", value: "CorpDiv" },
    { label: "Individual IDCW", value: "NonCorpDiv" },
  ];

  const handleChangeFundCode = (event) => {
    setData("");
    const selectedValue = event.target.value;
    setSelectedOptionFundCode(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns1(true);
    } else {
      setShowAdditionalDropdowns1(false);
    }
  };

  const handleChangeOptiinDesc = (event) => {
    setData("");
    const selectedValue = event.target.value;
    setSelectedOptionOptionDesc(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns2(true);
    } else {
      setShowAdditionalDropdowns2(false);
    }
  };
  const handleChangedate = (StartDatenew) => {
    const datestart = dayjs(StartDatenew).format("YYYY-MM-DD");
    setValuedateLatest(datestart);
    // alert(datestart, "datestart")
  };

  const isDateInFuture = (date) => {
    return dayjs(date).isAfter(dayjs(), "day");
  };
  const handleChangedateEnd = (newValue) => {
    const val = dayjs(newValue).format("YYYY-MM-DD");
    setlastDate(val);
  };

  function exportToExcel(data, columns) {
    const dataNew = data.map((item) => {
      const dataItem = {};
      columns.forEach((column) => {
        dataItem[column.label] = item[column.value];
      });
      return dataItem;
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataNew);
    const columnWidths = [
      { wch: 11 },
      { wch: 9 },
      { wch: 50 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
    ];
    worksheet["!cols"] = columnWidths;
    const cellNumberFormat = "#,##0.00";
    const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    worksheet[cell].z = cellNumberFormat;
    XLSX.utils.book_append_sheet(workbook, worksheet, "IDCWHistory");
    XLSX.writeFile(workbook, "IDCWHistory.xlsx");
  }

  const currentTableData = useMemo(() => {
    if (data != null) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null) {
        if (data.length > 0) {
          // return data.slice(firstPageIndex, lastPageIndex);
          return data.slice((current - 1) * PageSize, current * PageSize);
        }
      }
    }
  }, [current, data, PageSize]);

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <button>
          <i className="fa fa-angle-double-left"></i>
        </button>
      );
    }
    if (type === "next") {
      return (
        <button>
          <i className="fa fa-angle-double-right"></i>
        </button>
      );
    }
    return originalElement;
  };

  // const buttonGo = (event) => {
  //     event.preventDefault();
  //     const dateString = dayjs(valuedate).format('YYYY-MM-DD');
  //     const dateStringLast = dayjs(StartDate).format('YYYY-MM-DD');
  //     if (valuedatelatest != '' && endDate != '' &&  values != '' && optiondesc != '') {
  //     GetPostMethodData(BaseURL + "GetDividendHistory", {
  //         "type": values,
  //         "IVSchemeCode": optiondesc,
  //         "IDstartdate": valuedatelatest,
  //         "IDenddate": endDate
  //     }).then((data) => {
  //         if (data.data != null && data.data.length > 0) {
  //             setData(DecryptAESdata(data.data));
  //         }
  //     }, [valuedatelatest, endDate, Valuesdrop, values]);
  // }
  // else if (valuedatelatest === '' && endDate === '' &&  values != '' && optiondesc != '') {
  //     GetPostMethodData(BaseURL + "GetDividendHistory", {
  //         "type": values,
  //         "IVSchemeCode":optiondesc,
  //         "IDstartdate": dateString,
  //         "IDenddate": dateStringLast
  //     }).then((data) => {
  //         if (data.data != null && data.data.length > 0) {
  //             setData(DecryptAESdata(data.data));
  //         }
  //     }, [dateString, dateStringLast, optiondesc, values]);
  // } else {
  //     setData('');
  // }
  // }
  const buttonGo = (event) => {
    setCurrent(1);
    event.preventDefault();
    const dateString = dayjs(valuedate).format("YYYY-MM-DD");
    const dateStringLast = dayjs(StartDate).format("YYYY-MM-DD");

    if (values !== "" && optiondesc !== "") {
      const apiParams = {
        type: values,
        IVSchemeCode: optiondesc,
        IDstartdate: "",
        IDenddate: "",
      };

      // if (valuedatelatest !== '' && endDate !== '') {
      //     apiParams.IDstartdate = valuedatelatest;
      //     apiParams.IDenddate = endDate;
      // }
      // else if (valuedatelatest !== '' && endDate === '') {
      //     apiParams.IDstartdate = valuedatelatest;
      //     apiParams.IDenddate = dateString;
      // }
      // else if (valuedatelatest === '' && endDate !== '') {
      //     apiParams.IDstartdate = dateStringLast;;
      //     apiParams.IDenddate = endDate;
      // }
      // else {
      //     apiParams.IDstartdate = dateStringLast;
      //     apiParams.IDenddate = dateString;
      // }
      if (valuedatelatest !== "" && endDate !== "") {
        if (dayjs(endDate).isAfter(dayjs(valuedatelatest))) {
          apiParams.IDstartdate = valuedatelatest;
          apiParams.IDenddate = endDate;
        } else {
          alert(`End date can't be smaller than Start date.`);
          return;
        }
      } else if (valuedatelatest !== "" && endDate === "") {
        apiParams.IDstartdate = valuedatelatest;
        apiParams.IDenddate = dateString;
      } else if (valuedatelatest === "" && endDate !== "") {
        if (dayjs(endDate).isAfter(dayjs(dateStringLast))) {
          apiParams.IDstartdate = dateStringLast;
          apiParams.IDenddate = endDate;
        } else {
          alert(`End date can't be smaller than Start date.`);
          return;
        }
      } else {
        apiParams.IDstartdate = dateStringLast;
        apiParams.IDenddate = dateString;
      }

      GetPostMethodData(BaseURL + "GetDividendHistory", apiParams).then(
        (data) => {
          if (data.data != null && data.data.length > 0) {
            setData(DecryptAESdata(data.data));
          }
        },
      );
    } else {
      setData("");
    }
  };

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: "",
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFund(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "drop")
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundCode(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "dropFundcode")
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "IDWC",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: selectedOptionFundtype,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundType(DecryptAESdata(data.data));
        setloadingshow(false);
      }
      // if(selectedOptionFundtype != ""){
      //     document.getElementsByClassName('btn-go-nav').style.display = "block";
      // }
    });
  }, [BaseURL, values, selectedOptionFundCode, selectedOptionFundtype]);

  const handleChange = (e) => {
    e.preventDefault();
    const valueLi = e.currentTarget.getAttribute("data-value");
    setValues(valueLi);
    setActiveTab(valueLi);
    setValuesdrop("");
    setShowAdditionalDropdowns(false);
    setSelectedOptionOptionDesc("");
    setSelectedOption("");
    // setData('')
  };
  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <section className="navs-and-dividends-section">
              <div className="container-fluid p-0">
                <div className="tab-content sub-content" id="pills-tabContent">
                  <div
                    className="tab-pane nav-tab fade show active"
                    id="pills-nav"
                    role="tabpanel"
                   
                  >
                    <div className="container">
                      <div
                        className="tab-content sub-content"
                        id="nav-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="pills-latest-nav"
                          role="tabpanel"
                         
                        >
                          {/* <h2>NAV History</h2> */}
                          <div className="tile inner-tab" id="">
                            <ul
                              className="nav nav-tabs nav-justified"
                              role="tablist"
                            >
                              <li
                                className="nav-item"
                                data-value="Equity"
                                onClick={(e) => handleChange(e)}
                              >
                                <a
                                  className={`nav-link ${activeTab === "Equity" ? "active" : ""}`}
                                  id="equity-schemes-tab"
                                  data-toggle="tab"
                                  href="#equity-schemes"
                                  role="tab"
                                  aria-controls="equity-schemes"
                                  aria-selected="true"
                                >
                                  Equity
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="fixedincome"
                                onClick={(e) => handleChange(e)}
                              >
                                <a
                                  className={`nav-link ${activeTab === "fixedincome" ? "active" : ""}`}
                                  id="arbitrage-schemes-tab"
                                  data-toggle="tab"
                                  href="#arbitrage-schemes"
                                  role="tab"
                                  aria-controls="arbitrage-schemes"
                                  aria-selected="false"
                                >
                                  Fixed Income
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="Hybrid"
                                onClick={(e) => handleChange(e)}
                              >
                                <a
                                  className={`nav-link ${activeTab === "Hybrid" ? "active" : ""}`}
                                  id="debt-schemes-tab"
                                  data-toggle="tab"
                                  href="#debt-schemes"
                                  role="tab"
                                  aria-controls="debt-schemes"
                                  aria-selected="false"
                                >
                                  Hybrid
                                </a>
                              </li>
                            </ul>

                            <div className="tab-content inner-content">
                              <div
                                className="tab-pane latest-nav-tab fade show active"
                                id="equity-schemes"
                                role="tabpanel"
                                aria-labelledby="equity-schemes-tab"
                              >
                                <div className="header-wrapper">
                                  {/* <form action=""> */}
                                  <div className="header-container">
                                    <div className="form-container">
                                      <label htmlFor="first-dropdown">
                                        Select Fund
                                      </label>

                                      <div className="select-container">
                                        <select
                                          id="first-dropdown"
                                          className="fund-selector"
                                          onChange={handleChangeFundName}
                                          value={selectedOptionFundCode}
                                        >
                                          <option value="">
                                            Please Select Fund
                                          </option>

                                          {dataDropFund &&
                                            dataDropFund.map(
                                              ({ schemecode, schemename }) => (
                                                <option value={schemecode}>
                                                  {schemename}
                                                </option>
                                              ),
                                            )}
                                        </select>
                                        <i
                                          className="fa fa-caret-down"
                                          aria-hidden="true"
                                        ></i>
                                      </div>

                                      {showAdditionalDropdowns && (
                                        <div>
                                          <label htmlFor="second-dropdown">
                                            Select Plan
                                          </label>
                                          <div className="select-container">
                                            <select
                                              id="second-dropdown"
                                              className="fund-selector"
                                              onChange={handleChangeFundCode}
                                              value={selectedOptionFundtype}
                                            >
                                              <option value="">
                                                Please Select Plan
                                              </option>

                                              {DropdownFundCode &&
                                                DropdownFundCode.map(
                                                  ({ PlanType }) => (
                                                    <option value={PlanType}>
                                                      {PlanType}
                                                    </option>
                                                  ),
                                                )}
                                            </select>
                                            <i
                                              className="fa fa-caret-down"
                                              aria-hidden="true"
                                            ></i>
                                          </div>
                                          <label htmlFor="third-dropdown">
                                            Select Option
                                          </label>
                                          <div className="select-container">
                                            {selectedOptionFundtype === "" ? (
                                              <select
                                                id="third-dropdown"
                                                className="fund-selector"
                                                onChange={
                                                  handleChangeOptiinDesc
                                                }
                                                value={optiondesc}
                                              >
                                                <option value="">
                                                  Please Select Option
                                                </option>
                                              </select>
                                            ) : (
                                              <select
                                                id="third-dropdown"
                                                className="fund-selector"
                                                onChange={
                                                  handleChangeOptiinDesc
                                                }
                                                value={optiondesc}
                                              >
                                                <option value="">
                                                  Please Select Option
                                                </option>

                                                {DropdownFundType &&
                                                  DropdownFundType.map(
                                                    ({
                                                      SchemeCode,
                                                      OptionDesc,
                                                    }) => (
                                                      <option
                                                        value={SchemeCode}
                                                      >
                                                        {OptionDesc}
                                                      </option>
                                                    ),
                                                  )}
                                              </select>
                                            )}

                                            <i
                                              className="fa fa-caret-down"
                                              aria-hidden="true"
                                            ></i>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <div className="cale" id="datedrop">
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DemoContainer
                                          components={[
                                            "DatePicker",
                                            "DatePicker",
                                          ]}
                                        >
                                          <DatePicker
                                            label="Start Date"
                                            value={StartDate}
                                            disableFuture // Disable future dates
                                            format="DD/MMM/YYYY"
                                            onChange={(StartDatenew) =>
                                              handleChangedate(StartDatenew)
                                            }
                                          />
                                          <DatePicker
                                            label="End Date"
                                            value={valuedate}
                                            disableFuture // Disable future dates
                                            format="DD/MMM/YYYY"
                                            onChange={(newValue) =>
                                              handleChangedateEnd(newValue)
                                            }
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>
                                    </div>
                                    <div className="export-excel">
                                      <img
                                        src={execl}
                                        onClick={() =>
                                          exportToExcel(data, columns)
                                        }
                                      ></img>
                                    </div>
                                  </div>
                                  {/* </form> */}
                                </div>
                                {optiondesc != "" ? (
                                  <div className="btn-go">
                                    <button onClick={buttonGo}>
                                      VIEW IDCW
                                    </button>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                                <div className="funds-container">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th rowspan="2">Scheme Name</th>
                                          <th rowspan="2" className="">
                                            Record Date
                                          </th>
                                          <th
                                            colspan="2"
                                            className="text-center"
                                          >
                                            IDCW Per Unit (Rs.)
                                          </th>
                                          <th
                                            rowspan="2"
                                            className="text-right"
                                          >
                                            Ex-IDCW NAV on Record Date
                                          </th>
                                        </tr>
                                        <tr>
                                          <th className="fund-type text-center">
                                            Individual
                                          </th>
                                          <th className="fund-type text-center">
                                            Corporate
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentTableData === null ? (
                                          <h5 className="errormsgComNew">
                                            No Data Available !!!
                                          </h5>
                                        ) : (
                                          ""
                                        )}
                                        {currentTableData &&
                                          currentTableData.map(
                                            ({
                                              categoryid,
                                              CorpDiv,
                                              nav,
                                              navdate,
                                              NonCorpDiv,
                                              schemename,
                                            }) => (
                                              <tr>
                                                <td>{schemename}</td>
                                                <td>{navdate}</td>
                                                <td className="text-end">
                                                  {Number(
                                                    NonCorpDiv,
                                                  ).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 8,
                                                    maximumFractionDigits: 8,
                                                  })}
                                                </td>
                                                <td className="text-end">
                                                  {Number(
                                                    CorpDiv,
                                                  ).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 8,
                                                    maximumFractionDigits: 8,
                                                  })}
                                                </td>
                                                <td className="text-end">
                                                  {Number(nav).toLocaleString(
                                                    "en-IN",
                                                    {
                                                      minimumFractionDigits: 4,
                                                      maximumFractionDigits: 4,
                                                    },
                                                  )}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        {loadingshow ? (
                                          <div className="textcentervertex">
                                            <img
                                              src={animation}
                                              alt="Loading"
                                            />
                                            <div className="model_popup">
                                              Please Wait...
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>

                                 {['LD', 'SD', 'FF', 'IF'].includes(selectedOptionFundCode) && (
                                                                <div className="note-section" style={{ marginTop: '16px', padding: '12px 16px', background: '#f8f9fa', borderLeft: '4px solid #0473ea', fontSize: '14px' }}>
                                                                <strong>Note:</strong>{' '}
                                                                {selectedOptionFundCode === 'LD' && 'JM Ultra Short to Short Term Fund (Erstwhile known as JM Low Duration Fund)'}
                                                                {selectedOptionFundCode === 'SD' && 'JM Short Term Fund (Erstwhile known as JM Short Duration Fund)'}
                                                                {selectedOptionFundCode === 'FF' && 'JM Dynamic Term Fund (Erstwhile known as JM Dynamic Bond Fund)'}
                                                                {selectedOptionFundCode === 'IF' && 'JM Medium to Long Term Fund (Erstwhile known as JM Medium to Long Duration Fund)'}
                                                                </div>
                                                            )}

                                {/* {currentTableData != null && currentTableData !== [] ? (

                                                                    <>
                                                                        <Pagination
                                                                            className="pagination-data"
                                                                            showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                                                                            onChange={PaginationChange}
                                                                            total={currentTableData.length != null ? currentTableData.length : 0}
                                                                            current={current}
                                                                            pageSize={PageSize}
                                                                            showSizeChanger={false}
                                                                            itemRender={PrevNextArrow}
                                                                        // onShowSizeChange={PerPageChange}
                                                                        /></>
                                                                ) 
                                                                : (
                                                                    <p className="errorPeer">No Data Found</p>
                                                                )
                                                                } */}
                                {/* {currentTableData === "" && currentTableData === null ? (
                                                                    <div className="textCenter">
                                                                        <img alt="No Data Found" src={NodatafoundImg}></img>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DividendHistory;
